<template>
	<!-- eslint-disable-next-line vue/no-v-html -->
	<div :class="display" class="has-svg" v-html="inlineHtml" />
</template>

<script>
import { svgs, isKnown, isReady } from './svg-library';

export default {
	name: 'DpSvg',
	props: {
		svg: { type: String, default: null },
		block: { type: Boolean, default: false },
		placeholderViewbox: { type: String, default: null },
	},
	data: () => svgs,
	computed: {
		display() { return this.block ? 'is-block' : 'is-inline-block'; },
		inlineHtml() {
			if (!this.svg) { return; }
			if (isReady() && !isKnown(this.svg)) {
				console.warn(`Inline SVG not found: ${this.svg}`);
			}
			return isKnown(this.svg) ? this.data[this.svg] : this.placeholderHtml;
		},
		placeholderHtml() {
			if (!this.placeholderViewbox) { return; }
			return `<svg viewBox="${this.placeholderViewbox}" xmlns="http://www.w3.org/2000/svg"></svg>`;
		},
	},
};
</script>
